import { ChevronDownIcon } from '@chakra-ui/icons'
import type { ButtonProps } from '@chakra-ui/react'
import { Button, Grid, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, useDisclosure, useStyleConfig } from '@chakra-ui/react'
import React, { createContext, forwardRef } from 'react'
import { Link } from 'react-router'

export interface MenuItemProps extends ButtonProps {
  children: React.ReactNode
  href?: string
  disabled?: boolean
}

export const MenuItem = forwardRef(function MenuItem({ children, href, disabled, sx, ...rest }: MenuItemProps, ref) {
  const styles = useStyleConfig('MenuItem', rest)

  return (
    <Button
      ref={ref}
      variant="link"
      as={Link}
      to={href}

      isDisabled={disabled}
      __css={styles}
      sx={{
        ...sx,
        pointerEvents: disabled ? 'none' : undefined
      }}
      {...rest}
    >
      {children}
    </Button>
  )
})

export const DropdownMenuItemContext = createContext<{onClose: () => void} | null>(null)

export const DropdownMenuItem = forwardRef(function DropdownMenuItem({ children, label, disabled, sx, ...rest }: MenuItemProps & { label: React.ReactNode }, ref) {
  const { isOpen, onToggle, onClose } = useDisclosure()
  const styles = useStyleConfig('MenuItem', rest)

  return <Popover
    placement="bottom-end"
    isOpen={isOpen}
    onOpen={onToggle}
    onClose={onClose}
    closeOnBlur={true}
    returnFocusOnClose={false}
  >
    <PopoverTrigger>
      <Button
        display={'flex'}
        variant="link"
        rightIcon={<ChevronDownIcon color={'primary.500'} sx={{ w: '1.125rem', h: '1.125rem', transform: isOpen ? 'rotate(180deg)' : '' }} />}
        {...rest}
        __css={styles}
        sx={{
          ...sx,
          pointerEvents: disabled ? 'none' : undefined
        }}
        children={label}
      />
    </PopoverTrigger>

    <PopoverContent>
      <PopoverArrow />
      <PopoverBody sx={{ p: 0 }}>
        <DropdownMenuItemContext.Provider value={{ onClose }}>
          <Grid sx={{ gap: 0.5, p: 0 }}>
            {children}
          </Grid>
        </DropdownMenuItemContext.Provider>
      </PopoverBody>
    </PopoverContent>
  </Popover>
})